import {setTitle} from "@src/util";

export default function (props: { time: string }) {
	const {time} = props;
	setTitle('温馨提示')
	return <div className="holiday">
		<p className="title">尊敬的客户您好</p>
		<p>由于金融分期服务商[润雨同舟（深圳）融资租赁有限公司]春节放假时间为{time}，在此期间将对系统进行全面升级</p>
		<p>给您带来不便，敬请谅解！</p>
	</div>
}